<template>
  <div>
    <div class="container-fluid">
      <div data-widget-group="group1">
        <ol class="breadcrumb">
          <li class="active">
            <router-link to="/admin">Dashboard</router-link>
          </li>
          <li class="active"><a href="#">Add Employee</a></li>
        </ol>
        <div class="panel-body locationform">
          <div v-if="message" class="alert-danger alert visibility" role="alert">
            {{ message }}
          </div>
          <div v-if="SuccessMessage" class="alert-info alert visibility" role="alert">
            {{ SuccessMessage }}
          </div>
          <form @submit.prevent="submitForm">
            <div class="row">
                  <legend>Add / Edit Employee:</legend>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>First Name *</label>
                      <input
                        v-model="employeeData.first_name"
                        v-validate="'required'"
                        type="text"
                        placeholder="First Name"
                        class="form-control"
                        name="firstName"
                      />
                      <span v-if="errors.has('firstName')">
                        {{ errors.first('firstName') }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Last Name *</label>
                      <input
                        v-model="employeeData.last_name"
                        v-validate="'required'"
                        type="text"
                        class="form-control"
                        placeholder="Last Name"
                        name="LastName"
                      />
                      <span v-if="errors.has('LastName')">
                        {{ errors.first('LastName') }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Email*</label>
                      <input
                        v-model="employeeData.email"
                        v-validate="'required|email'"
                        type="text"
                        class="form-control"
                        placeholder="Email Id"
                        name="emailId"
                         data-vv-as="Email Address"
                      />
                      <span v-if="errors.has('emailId')">
                        {{ errors.first('emailId') }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>User Name*</label>
                      <input
                        v-model="employeeData.username"
                        v-validate="'required'"
                        type="text"
                        class="form-control"
                        placeholder="Username"
                        name="userName"
                         data-vv-as="User Name"
                      />
                      <span v-if="errors.has('userName')">
                        {{ errors.first('userName') }}
                      </span>
                    </div>
                  </div>
            </div>
            <div class="row">
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Mobile Number*</label>
                      <input
                        v-model="employeeData.mobile"
                        v-validate="'required|phone'"
                        type="text"
                        class="form-control"
                        placeholder="Mobile Number"
                        name="MobileNumber"
                      />
                      <span v-if="errors.has('MobileNumber')">
                        {{ errors.first('MobileNumber') }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Employee Code*</label>
                      <input
                        v-model="employeeData.employee_code"
                        v-validate="'required'"
                        type="text"
                        class="form-control"
                        placeholder="Employee Code"
                        name="employee_code"
                      />
                      <span v-if="errors.has('employee_code')">
                        {{ errors.first('employee_code') }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Role*</label>
                     <Select2SearchWithToken
                        :remoteControl="'kspgAPI/BrandEmployee/roleList'"
                        :selectedOptionArray ="roleAlready"
                        @selectedData="roleSelect"
                      ></Select2SearchWithToken>
                      Last saved: {{employeeData.role_name}}
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Manager*</label>
                     <Select2SearchWithToken
                        :remoteControl="'kspgAPI/BrandEmployee/managerList'"
                        :selectedOptionArray ="managerAlready"
                        @selectedData="managerSelect"
                      ></Select2SearchWithToken>
                      Last saved: {{employeeData.manager_name}}
                    </div>
                  </div>
            </div>
           <div class="row">
             <div class="col-md-3">
                    <div class="form-group">
                      <label>Branch*</label>
                     <Select2SearchWithToken
                        :remoteControl="'kspgAPI/Branch/list'"
                        :selectedOptionArray ="branchAlready"
                        @selectedData="branchSelect"
                      ></Select2SearchWithToken>
                      Last saved: {{employeeData.branch_name}}
                    </div>
                  </div>
           </div>
            <div class="row">
              <div class="col-sm-3 col-sm-offset-9">
                        <div class="form-group">
                          <button
                            class="btn-raised btn-primary btn fixcolorAs"
                            :disabled="loading"
                          >
                            <span
                              v-show="loading"
                              class="spinner-border spinner-border-sm"
                            ></span>
                            <span>Submit</span>
                          </button>
                        </div>
                  </div>
            </div>           
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import chield from './components/child';
import UserService from '../services/user.service';

import Select2SearchWithToken from './components/Select2SearchWithToken';

// import ModelSelectEnquery from './components/ModelSelectEnquery'
import VeeValidate from 'vee-validate';
const phoneRule = {
  getMessage(field, args) {
    return `The ${field} must be either a valid phone number`;
  },
  validate(value, args) {
    
    const MOBILEREG = /^(0|[+91]{3})?[6-9][0-9]{9}$/;
    
    // Check for either of these to return true
    return MOBILEREG.test(value);
  }
};

// Extend VeeValidate with our new custom rule
VeeValidate.Validator.extend('phone', phoneRule);

function initialState() {
  return {
          mobile:'',
          email:'',
          username:'',
        
          first_name:'',
          last_name:'',
          employee_code:'',
          branch:'',
          manager_id:'',
          role:'',
      }
}
export default {
  name: 'addEmployee',
  data() {
    return {
      loading:false,
      isReadOnly:true,
      message: '',
      SuccessMessage:'',
      employeeData: initialState(),
      managerAlready:{},
      roleAlready:{},
      branchAlready:{},
    };
  },
  components: { Select2SearchWithToken},
  computed: {
  },
  beforeCreate() {
    this.$store.commit('SET_LAYOUT', 'app-layout');
  },
  methods: {
    managerSelect(val){
      this.employeeData.manager_id = val;
    },
    roleSelect(val){
       this.employeeData.role = val;
    },
    branchSelect(val){
      this.employeeData.branch = val;
    },
    submitForm() {
      this.$validator.validateAll().then((res) => {
        // if (!res) {
        //   // handle input errors.
        //   this.message = 'Please Fill all menditory Options';
        //     setTimeout(() => (this.message = false), 5000);
        //   return;
        // }
        if (res) {
          let loader = this.$loading.show();
          UserService.postMetod(
            'kspgAPI/BrandEmployee/update',
            this.employeeData
          ).then(
            (response) => {
              this.SuccessMessage = response.data.message;
              setTimeout(() => (this.SuccessMessage = false), 5000);
              this.loading = false;
              // on success reset values
              if (response.data.status) {
                this.resetWindow();
                /*Clear Validation */
                 this.$nextTick(() => {
                    this.errors.clear();
                    this.$nextTick(() => {
                        this.$validator.reset();
                    });
                });
              }
            },
            (error) => {
              this.loading = false;

              this.message =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
          setTimeout(() => {loader.hide()}, 1000)
        } else {
          this.message = 'Please correct all error!';
        }
      });
    },
    resetWindow: function () {
      Object.assign(this.$data.employeeData, initialState());
    },
    getPrefilledData() {
      let loader = this.$loading.show();
      /*get  Employee Data */
      let param = {};
      param.id = this.$route.params.id;
      UserService.getMetod('kspgAPI/BrandEmployee/detail', param).then(
        (response) => {
          // alert(response.data.models);
          // vm.results = response.data.models
          const { register } = response.data;
          this.employeeData = register;
        },
        (error) => {
          this.loading = false;

          this.ErrorMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
            setTimeout(() => (this.ErrorMessage = false), 5000);
        }
      );
      // this.skyloEnd();
      setTimeout(() => {loader.hide()}, 2000)
    },
  }, 
  created() {
    this.getPrefilledData();
  },
};
</script>
<style>
.visibility {
  visibility:visible !important;
}

</style>